export default function internalNav() {

	let internalNav;
	let ageOptions;
	let audienceOptions;
	let audience = '';
	let age = '';
	let filter = '';

	const init = () => {
		internalNav = document.querySelector('.internal-page-nav-page-dropdown-section');
		if( !internalNav ) return;

		initCustomSelect();

		getURLVariables();

		audienceUpdated();
		navUpdate();
		updateAudience(audience);
	}

	const getURLVariables = () => {
		ageOptions = internalNav.querySelector('select.age_options');
		audienceOptions = internalNav.querySelector('select.audience');

		const searchParams = new URLSearchParams(window.location.search);

		if (searchParams.has('age')) {
			const selectedAge = searchParams.get('age');
			ageOptions.value = selectedAge;
			ageOptions.dispatchEvent(new Event('change'));
			age = selectedAge;
		}
		if (searchParams.has('audience')) {
			const selectedAudience = searchParams.get('audience');
			audienceOptions.value = selectedAudience;
			audienceOptions.dispatchEvent(new Event('change'));
			audience = selectedAudience;
			updateAudience(selectedAudience)
		}
		ageOptions.addEventListener('change', (event) => {
			age = event.target.value;
			navUpdate();
		});
		audienceOptions.addEventListener('change', (event) => {
			audience = event.target.value;
			audienceUpdated();
			navUpdate();
		});

		if (age == "" && audience == "") {
			age = ageOptions.value;
			audience = audienceOptions.value;
		}
	};

	const audienceUpdated = function(){
		//age has changed. make sure the audience has content. if not remove from the drop down
		let ages = [];
		ageOptions.querySelectorAll('option').forEach((option) => {
			ages.push(option.value);
		})
		let matchingAge = false;
		let availableAge = false;
		const sections = document.querySelectorAll('section');
		ages.forEach((ageValue) => {
			let hasMatches = false;
			sections.forEach((section) => {
				if(section.dataset.filterAge_options !== undefined || section.dataset.filterAudiences !== undefined){
					if(section.dataset.filterAge_options.includes(ageValue) && section.dataset.filterAudiences.includes(audience)){
						hasMatches = true;
					}
				}
			});
			let ageSelect = internalNav.querySelector('.select-list.age_options');
			if(!hasMatches){
				if(ageSelect){
					ageSelect.querySelector(`li[data-value="${ageValue}"]`).classList.add('is-hidden');
					if(age == ageValue){
						//the active age has no content
						matchingAge = true;
					}
				}
			}else{
				ageSelect.querySelector(`li[data-value="${ageValue}"]`).classList.remove('is-hidden');
				if(!availableAge){
					availableAge = ageValue;
				}
			}

			if(matchingAge){
				ageOptions.value = availableAge;
				ageOptions.dispatchEvent(new Event('change'));
				age = availableAge;
			}
		});
	}

	const navUpdate = function(){
		if(age || audience){
			const sections = document.querySelectorAll('section');
			sections.forEach((section) => {
				let matched = true;
				if(section.dataset.filterAge_options !== undefined || section.dataset.filterAudiences !== undefined){
					//theyve got a filter defined make it hidden by default
					matched = false;
					if(section.dataset.filterAge_options === "" && section.dataset.filterAudiences === ""){
						matched = true;
					}
					if (
						((age && section.dataset.filterAge_options.includes(age)) || !age) &&
						((audience && section.dataset.filterAudiences.includes(audience)) || !audience)
					) {
						matched = true;
					}
				}
				if(!matched){
					section.classList.add('is-hidden');
				}else{
					section.classList.remove('is-hidden');
				}
			});
			const params = new URLSearchParams(window.location.search);
			if (age) {
				params.set('age', age);
			} else {
				params.delete('age');
			}
			if (audience) {
				params.set('audience', audience);
			} else {
				params.delete('audience');
			}
			window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
		}
	}

	const initCustomSelect = () => {

		document.querySelectorAll('.int-nav-select').forEach((custSelect) => {
			const select = custSelect.querySelector('select');
			const options = custSelect.querySelectorAll('option');
			const selectLabel = document.createElement('div');
			const selectList = document.createElement('ul');
			const selectListWrap = document.createElement('div');
			const listItems = new Array();
			const trigger = document.createElement('div');
			let selectIndex = 0;
			let selectListItemQuery;


			const initSelectComponent = () => {
				selectListWrap.classList.add('select-list-wrap');
				selectList.classList.add('select-list');

				selectList.className = [...select.classList, ...selectList.classList].join(' ');
				selectListWrap.appendChild(selectList);
				custSelect.appendChild(selectListWrap);

				selectLabel.classList.add('select-label');
				selectLabel.innerHTML = options[0].innerHTML;
				custSelect.appendChild(selectLabel);

				trigger.classList.add('select-trigger');
				custSelect.appendChild(trigger);

				options.forEach((option, i) => {
					const listItem = document.createElement('li');
					const optionLabel = document.createElement('span');
					optionLabel.innerHTML = option.innerHTML;
					listItem.appendChild(optionLabel);
					listItem.setAttribute('data-value', option.value);
					listItem.setAttribute('data-index', i);
					listItem.setAttribute('role', 'option');
					listItem.setAttribute('aria-selected', 'false');
					listItem.setAttribute('aria-label', option.innerHTML);

					selectList.appendChild(listItem);
					listItems.push(listItem);
				});

				select.addEventListener('change', () => {
					selectLabel.innerHTML =  select.options[select.selectedIndex]?.innerHTML;
					listItems.forEach((listItem) => {
						listItem.classList.remove('is-selected');
						if (listItem.getAttribute('data-value') === select.value) {
							listItem.classList.add('is-selected');
						}
					});

					const selectIndex = select.selectedIndex;
					const listItem = listItems[selectIndex];
					const listItemIndex = listItem.getAttribute('data-index');
					const listItemClone = listItem.cloneNode(true);
					listItems.splice(listItemIndex, 1);
					listItems.splice(selectIndex, 0, listItemClone);
					selectList.innerHTML = '';
					listItems.forEach((listItem) => {
						selectList.appendChild(listItem);
					});

					const selectedListItem = selectList.querySelector('.is-selected');
					selectList.insertBefore(selectedListItem, selectList.querySelector('li'));

					selectListItemQuery = selectList.querySelectorAll('li');
				});

				trigger.addEventListener('click', () => {
					openSelect();
				});

				document.addEventListener('click', (event) => {
					if (!custSelect.contains(event.target)) {
						closeSelect();
					}
				});

				initADACompliance();

				window.addEventListener('resize', handleWindowResize);
				handleWindowResize();

				// hide select //
				select.style.display = 'none';
			};

			const handleListItemClick = (e) => {
				e.preventDefault();

				handleSelection(e.target.getAttribute('data-value') );

				closeSelect();
			};

			const openSelect = () => {
				selectListItemQuery = selectList.querySelectorAll('li');
				selectListItemQuery[0].classList.add('is-focused');

				selectListWrap.classList.add('is-open');
				selectIndex = 0;

				listItems.forEach((listItem, i) => {
					listItem.addEventListener('click', handleListItemClick);
				});
			};

			const closeSelect = () => {
				selectListWrap.classList.remove('is-open');
				if( selectListItemQuery && selectListItemQuery.length > 0 ){
					selectListItemQuery.forEach((listItem) => {
						listItem.classList.remove('is-focused');
						listItem.removeEventListener('click', handleListItemClick);
					});
				}
				custSelect.blur();
			};

			const handleWindowResize = () => {
				let largestOptionWidth = 0;
				listItems.forEach((listItem) => {
					let w = listItem.querySelector('span').offsetWidth;
					if(w > largestOptionWidth) {
						largestOptionWidth = w;
					}
				});
				selectLabel.style.width = `${largestOptionWidth + 5}px`;
			};

			/** ADA Compliance **/
			const initADACompliance = () => {

				custSelect.setAttribute('tabindex', '0');
				custSelect.addEventListener('keydown', (event) => {
					if (event.key === 'Enter') {
						closeSelect();
					}

					if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
						event.preventDefault();

						if( !selectListWrap.classList.contains('is-open') ) {
							openSelect();
							return false;
						}

						selectListItemQuery.forEach((listItem) => {
							listItem.classList.remove('is-focused');
						});

						(event.key === 'ArrowDown') ? selectIndex++ : selectIndex--;
						if (selectIndex < 0) selectIndex = selectListItemQuery.length - 1;
						if (selectIndex >= selectListItemQuery.length) selectIndex = 0;

						if (selectIndex < 0) selectIndex = selectListItemQuery.length - 1;
						if (selectIndex >= selectListItemQuery.length) selectIndex = 0;

						selectListItemQuery[selectIndex].classList.add('is-focused');
					}

					if (event.key === 'Escape') {
						closeSelect();
						event.preventDefault();
					}

					if (event.key === 'Tab') {
						closeSelect();
						event.preventDefault();
					}

					if (event.key === 'Enter' ) {
						handleSelection( (selectListItemQuery && selectListItemQuery.length > 0) ? selectListItemQuery[selectIndex].getAttribute('data-value') : listItems[selectIndex].getAttribute('data-value') );

						closeSelect();
						event.preventDefault();
					}

					if( event.key === 'Space' || event.key === ' ' ) {
						event.preventDefault();
						if( !selectListWrap.classList.contains('is-open') ) {
							openSelect();
							return false;
						}
						handleSelection(selectListItemQuery[selectIndex].getAttribute('data-value') );
						closeSelect();
					}

					/** select selectListItemQuery list item based on number or alphabet key press */
					if (event.key.match(/^[0-9a-zA-Z]$/)) {
						event.preventDefault();

						selectListItemQuery.forEach((listItem) => {
							listItem.classList.remove('is-focused');
						});

						let key = event.key.toLowerCase();
						let match = false;
						selectListItemQuery.forEach((listItem, i) => {
							const listItemText = listItem.querySelector('span').textContent.toLowerCase();
							if (listItemText.startsWith(key)) {
								selectListItemQuery[i].classList.add('is-focused');
								selectIndex = i;
								match = true;
							}
						});
						if (!match) {
							selectListItemQuery.forEach((listItem) => {
								listItem.classList.remove('is-focused');
							});
						}
					}

				});
			};

			const handleSelection = ( selectedValue ) => {
				select.value = selectedValue;
				select.dispatchEvent(new Event('change'));

				if (select.classList.contains( 'audience' ) ) {
					updateAudience( selectedValue );
				}
			};

			initSelectComponent();
		});
	};

	const updateAudience = (selection) => {

		const items = internalNav.querySelectorAll('.item-choices .item');
		items.forEach((item) => {
			item.classList.remove('hide');
			if (item.dataset.audience !== selection) {
				item.classList.add('hide');
			}
		});

	};

	init();
}
